import {useCallback, useEffect, useRef} from "react";
import lscache from "lscache";

import {gtmEventPhoneVerification} from "@pg-mono/google-tag-manager/src/gtm_event_phone_verification";

import {PHONE_VERIFICATION_CODE_SENT_LS_KEY} from "../../constants/phone_verification_constants";
import {useUserPhoneVerificationContext} from "../context/UserPhoneVerificationContext";
import {getPhoneVerificationCodeRemainingTime} from "../utils/get_phone_verification_code_remaining_time";
import {shouldAutoSendPhoneVerificationCode} from "../utils/should_auto_send_phone_verification_code";
import {usePhoneVerificationTimer} from "./use_phone_verification_timer";

const HTTP_STATUS_FOR_TOO_MANY_REQUESTS = 429;

export interface IPhoneVerificationCodeError {
    message: string;
    status: number;
}

interface IParams {
    isBusy: () => boolean;
    onError: (error: IPhoneVerificationCodeError) => void;
    onSendStart: () => void;
}

export const useSendPhoneVerificationCode = (params: IParams) => {
    const {isBusy, onError, onSendStart} = params;
    const {sendPhoneVerificationCode} = useUserPhoneVerificationContext();
    const {startTimer, stopTimer, timer, timerStartTime} = usePhoneVerificationTimer();
    const didStartRef = useRef(false);

    const sendCode = useCallback(async () => {
        startTimer();
        onSendStart();

        try {
            const response = await sendPhoneVerificationCode();

            if (response.error) {
                if (response.error.status === HTTP_STATUS_FOR_TOO_MANY_REQUESTS) stopTimer();

                onError(response.error);
                return;
            }

            lscache.set(PHONE_VERIFICATION_CODE_SENT_LS_KEY, "1");
        } catch {
            onError({message: "Wystąpił błąd podczas wysyłania kodu", status: 500});
        }
    }, [onError, onSendStart, sendPhoneVerificationCode, startTimer, stopTimer]);

    useEffect(() => {
        if (didStartRef.current) return;

        didStartRef.current = true;
        gtmEventPhoneVerification("view");

        if (shouldAutoSendPhoneVerificationCode(timerStartTime)) void sendCode();
    }, [sendCode, timerStartTime]);

    const resendCode = () => {
        // Same guards as the form: no competing requests while verifying, no resend during the cooldown.
        if (isBusy() || getPhoneVerificationCodeRemainingTime(timerStartTime) > 0) return;

        void sendCode();
    };

    return {resendCode, timer};
};
import {useCallback, useEffect, useRef} from "react";
import lscache from "lscache";

import {gtmEventPhoneVerification} from "@pg-mono/google-tag-manager/src/gtm_event_phone_verification";

import {PHONE_VERIFICATION_CODE_SENT_LS_KEY} from "../../constants/phone_verification_constants";
import {useUserPhoneVerificationContext} from "../context/UserPhoneVerificationContext";
import {getPhoneVerificationCodeRemainingTime} from "../utils/get_phone_verification_code_remaining_time";
import {shouldAutoSendPhoneVerificationCode} from "../utils/should_auto_send_phone_verification_code";
import {usePhoneVerificationTimer} from "./use_phone_verification_timer";

const HTTP_STATUS_FOR_TOO_MANY_REQUESTS = 429;

export interface IPhoneVerificationCodeError {
    message: string;
    status: number;
}

interface IParams {
    isBusy: () => boolean;
    onError: (error: IPhoneVerificationCodeError) => void;
    onSendStart: () => void;
}

export const useSendPhoneVerificationCode = (params: IParams) => {
    const {isBusy, onError, onSendStart} = params;
    const {sendPhoneVerificationCode} = useUserPhoneVerificationContext();
    const {startTimer, stopTimer, timer, timerStartTime} = usePhoneVerificationTimer();
    const didStartRef = useRef(false);

    const sendCode = useCallback(async () => {
        startTimer();
        onSendStart();

        try {
            const response = await sendPhoneVerificationCode();

            if (response.error) {
                if (response.error.status === HTTP_STATUS_FOR_TOO_MANY_REQUESTS) stopTimer();

                onError(response.error);
                return;
            }

            lscache.set(PHONE_VERIFICATION_CODE_SENT_LS_KEY, "1");
        } catch {
            onError({message: "Wystąpił błąd podczas wysyłania kodu", status: 500});
        }
    }, [onError, onSendStart, sendPhoneVerificationCode, startTimer, stopTimer]);

    useEffect(() => {
        if (didStartRef.current) return;

        didStartRef.current = true;
        gtmEventPhoneVerification("view");

        if (shouldAutoSendPhoneVerificationCode(timerStartTime)) void sendCode();
    }, [sendCode, timerStartTime]);

    const resendCode = () => {
        // Same guards as the form: no competing requests while verifying, no resend during the cooldown.
        if (isBusy() || getPhoneVerificationCodeRemainingTime(timerStartTime) > 0) return;

        void sendCode();
    };

    return {resendCode, timer};
};
